// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2DMMN","label":"CategoryService_label__23VuR","location":"CategoryService_location__D2q7y"};